import { get } from 'lodash-es';

import { emptyArray } from 'ui-components/default-props/empty';

class AsyncJobHelperClass {
  foldMultiJobResponse(multiJobGuids) {
    // [{ jobGuids: [] }] -> { jobGuids: [] }
    return multiJobGuids.reduce((acc, { jobGuids }) => {
      return {
        jobGuids: [...jobGuids, ...get(acc, 'jobGuids', emptyArray)],
      };
    });
  }
}

export const AsyncJobHelper = new AsyncJobHelperClass();
